import Cadastro from '@/pages/pedidoCompra/Cadastro'
import Listar from '@/pages/pedidoCompra/Listar'

export const pedidosCompraRoutes = [
    {
        path: '/pedidos-compras',
        name: 'pedidosCompras',
        component: Listar
    },
    {
        path: '/pedidos-compras/cadastro',
        name: 'pedidoCompraCadastro',
        component: Cadastro
    },
    {
        path: '/pedidos-compras/:id/editar',
        name: 'pedidoCompraEditar',
        component: Cadastro,
        props: true
    }
]

export default {}
